const config = {
  getEtaIntervalInMillis: 60 * 1000,
  getLastLocationIntervalInMillis: 5 * 1000,
  waitForLastLocationIntervalInMillis: 1000,
  baseUrl: process.env.REACT_APP_BASE_URL,
  landingPageUrl: process.env.REACT_APP_LANDING_PAGE_URL,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  launchDarklyKey: process.env.REACT_APP_LAUNCH_DARKLY_KEY
};

export default config;
